export default "__VITE_ASSET__CPIL6nd3__"